export const TASK_TYPE_COLOR = '#DCE3E5'

export const TASK_TYPE_TEXT_COLOR = '#263238'
